import React, { useState } from 'react'
import Loading from '../../components/Loading'

export default function Orders() {
    const [orderList, setOrderList] = useState([])
    const [pageLoading, setPageLoading] = useState(false)

    if (pageLoading) return <Loading />
    return (
        <div className='dashboar-theme'>
            <div className='table-data'>
                <div className='manage'>
                    <h2>Order List</h2>
                    {/* <OrderData
                        bookingList={bookingList}
                        sortedData={sortedData}
                        handleBookingStatus={handleBookingStatus}
                    /> */}
                </div>
            </div>
        </div>
    )
}
